import React, { useCallback, useEffect, useRef, useState } from "react";
import "./OnBoardingConfigurePost.scss";
import TemplateTypes01 from "../../.././TemplateTypes01.png";
import Avatar from "../../../Avatar.jpg";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import LeftArrowIcon from "../../../../components/icons/LeftArrowIcon";
import RightArrowIcon from "../../../../components/icons/RightArrowIcon";
import PreviewModal from "../propertypost/view/PreviewModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TemplatesApi } from "../../../../utils/api/Templates";
import toast from "react-hot-toast";
import { clientRoutes } from "../../../../utils/routes";
import { CommonHelpers } from "../../../../utils/helpers/common.helpers";
import { CommonEnums } from "../../../../enums/common.enums";
import CustomPageLoader from "../../../../components/loaders/CustomPageLoader";
import UpdateTemplateModal from "../../WorkspaceSheduleConfigure/UpdateTemplateModal";
import { getImageUrl } from "../../../../utils/helpers/common";
import { Modal } from "@mui/material";
import { PropertyApi } from "../../../../utils/api/Property";

interface PropertySetupPostProps {
  selectedPostTypeTitle?: string | null;
}

const OnBoardingConfigurePost = ({
  selectedPostTypeTitle = "N/A",
}: PropertySetupPostProps) => {
  const [activeTabs, setActiveTabs] = useState("auctionInfo");
  const [activeTab, setActiveTab] = useState("Facebook");
  const [sameTextToggle, setSameTextToggle] = useState(false);
  const [activeDotIndex, setActiveDotIndex] = useState(0);
  const [showScheduleForm, setShowScheduleForm] = useState(false);
  const [processingModalOpen, setProcessingModalOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [otherImagesIndex, setOtherImagesIndex] = useState(0);
  const [postPreviewIndex, setPostPreviewIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdateMainTemplateOpen, setIsUpdateMainTemplateOpen] =
    useState(false);
  const [isUpdateOtherImagesTemplateOpen, setIsUpdateOtherImagesTemplateOpen] =
    useState(false);
  const [selectedMainTemplateId, setSelectedMainTemplateId] = useState("");
  const [selectedOtherImagesTemplateId, setSelectedOtherImagesTemplateId] =
    useState("");
  const [activePostType, setActivePostType] = useState("Video Post");
  const allowedPostTypes = ["Image Post"];
  const [mainImageUrl, setMainImageUrl] = useState("");
  const [currentTemplateId, setCurrentTemplateId] = useState("");
  const [otherImagesUrl, setOtherImagesUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedPostType, setSelectedPostType] = useState<string | null>(null);
  const [confirmedPostType, setConfirmedPostType] = useState<string | null>(
    null
  );
  const [loadingPostType, setLoadingPostType] = useState<string | null>(null);
  const [step, setStep] = useState("select");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [onBoarding, setOnBoardingPost] = useState<any>(null);
  const [searchParams] = useSearchParams();
  const scheduleFormRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const [isPolling, setIsPolling] = useState(false);
  const onboarding_post_id = searchParams.get("onboarding_post_id");
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [isUpdateTemplateOpen, setIsUpdateTemplateOpen] = useState(false);
  const listingType = searchParams.get("listing_type") || undefined;
  const postType = searchParams.get("post_type") || undefined;
  const [scheduleDateTime, setScheduleDateTime] = useState<dayjs.Dayjs | null>(
    null
  );
  const [scheduleDate, setScheduleDate] = useState<Dayjs | null>(null);
  const [scheduleTime, setScheduleTime] = useState<Dayjs | null>(null);
  const [timeTo, setTimeTo] = useState("00:00");
  const [localPostStatus, setLocalPostStatus] = useState<string | null>(null);
  const [date, setDate] = useState<string>("");
  const [selectedButton, setSelectedButton] = useState("schedule");
  const templateTypeId = resolveReviewTemplateType(postType, listingType);
  const [updating, setUpdating] = useState(false);

  const postTypes = [
    { label: "Image Post" },
    { label: "Video Post" },
    { label: "Story Post" },
    { label: "Reel Post" },
  ];

  const tabs = [
    "Facebook",
    "Instagram",
    "Google Business",
    "Linkedin",
    "Youtube",
  ];

  const images = [
    "/images/property-inside.jpg",
    "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg",
    "https://as2.ftcdn.net/jpg/02/61/89/29/1000_F_261892957_6jyBXvEgM79iYr1eEiJKCosnVPJdvHHr.jpg",
  ];

  const handleOtherImagesPrev = () => {
    setOtherImagesIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleOtherImagesNext = () => {
    setOtherImagesIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handlePostPreviewPrev = () => {
    setPostPreviewIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handlePostPreviewNext = () => {
    setPostPreviewIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const fullText = `Featuring: 5 🛌  Bedrooms | 5 🛀  Bathrooms | 2 🚗 Car Spaces... more
💸 Price Range: $1,675,000 - $1,842,000
Discover a lifestyle that's more than extraordinary – it's truly exceptional. Nestled in the heart of Berwick Waters, this stunning property at 6 Rockbank Road offers everything you need to live like a star.
Don't miss the chance to experience the allure of celebrity living. Come and see what makes 6 Rockbank Road the ultimate address for those who demand the best.
Your dream lifestyle awaits!
📸 Explore More: https://www.realestate.com.au/property-house-vic-clyde...
For more information or to book a viewing,

Lern more at BrandFeeds [Brand feeds Link for this property here]

Contact
Sukhdeep Singh 📲 0420 879 430
Mohan Singh 📲 0426 250 579
#celebrityliving #dreamhome #luxurylifestyle #clydenorthrealestate 
#berwickwaters #melbournerealestate #homesforsale #luxuryhomes 
#realestategoals #propertyforsale #dreamliving #familyhome 
#investmentproperty`;

  const shortText = `Experience Celebrity Living at 📍 6 Rockbank Road, Clyde North Spaces...`;

  const handleUpdateTemplateConfirm = (
    templateId: string,
    imageUrl: string
  ) => {
    setCurrentTemplateId(templateId);
    setMainImageUrl(imageUrl);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000);
  }, []);

  const handleConfirm = () => {
    if (selectedPostType) {
      setConfirmedPostType(selectedPostType);
      setLoadingPostType(selectedPostType);
      setTimeout(() => {
        setLoadingPostType(null);
        setStep("configure");
      }, 1500);
    }
  };

  const startPolling = async () => {
    if (!onboarding_post_id || isPolling) return;

    setIsPolling(true);

    const pollInterval = setInterval(async () => {
      try {
        const res = await PropertyApi.GetOnboardingPostById(onboarding_post_id);
        if (res?.data?.success) {
          const updatedPost = res.data.data;
          setOnBoardingPost(updatedPost);

          const designActivities = [
            updatedPost?.image_post_design_activity_ref,
            updatedPost?.story_post_design_activity_ref,
            updatedPost?.video_post_design_activity_ref,
            updatedPost?.reel_post_design_activity_ref,
          ].filter((activity) => activity && activity._id);

          const allReady = designActivities.every(
            (activity) =>
              activity.design_status === "pending_for_social_media_upload"
          );

          if (allReady) {
            clearInterval(pollInterval);
            setIsPolling(false);
          }
        }
      } catch (err) {
        console.error("Polling error:", err);
        clearInterval(pollInterval);
        setIsPolling(false);
      }
    }, 3000);

    return () => clearInterval(pollInterval);
  };

  const fetchPost = useCallback(
    async (isInitial = false) => {
      if (!onboarding_post_id) return;

      try {
        if (isInitial) setLoading(true);

        const res = await PropertyApi.GetOnboardingPostById(onboarding_post_id);
        if (res?.data?.success) {
          const updatedPost = res.data.data;
          setOnBoardingPost(updatedPost);

          if (updatedPost.schedule_datetime) {
            const dt = dayjs(updatedPost.schedule_datetime);
            setScheduleDateTime(dt);
            setScheduleDate(dt);
            setScheduleTime(dt);
          }

          const updatedStatuses = [
            updatedPost?.image_post_design_activity_ref?.design_status,
            updatedPost?.story_post_design_activity_ref?.design_status,
            updatedPost?.video_post_design_activity_ref?.design_status,
            updatedPost?.reel_post_design_activity_ref?.design_status,
          ];

          const shouldPoll =
            updatedStatuses.includes("processing") ||
            !updatedStatuses.includes("pending_for_social_media_upload");

          if (shouldPoll && !intervalRef.current) {
            intervalRef.current = setInterval(() => fetchPost(false), 3000);
          } else if (!shouldPoll && intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        }
      } catch (err) {
        console.error("Failed to fetch property post:", err);
        if (isInitial) toast.error("Unable to load property post");
      } finally {
        if (isInitial) setLoading(false);
      }
    },
    [onboarding_post_id]
  );

  useEffect(() => {
    if (!onboarding_post_id) return;
    fetchPost(true);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [onboarding_post_id, fetchPost]);

  const handlePostTypeClick = (type: string) => {
    if (selectedPostType && selectedPostType !== type) {
      setLoadingPostType(selectedPostType);
    }

    setSelectedPostType(type);

    setTimeout(() => {
      setLoadingPostType(null);
      setStep("confirm");
    }, 800);
  };

  const formatPostType = (postType?: string) => {
    if (!postType) return "-";
    return postType
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  };

  const getScheduleDateTimeParts = () => {
    if (!date || !timeTo) return null;
    return {
      schedule_date: date,
      schedule_time: dayjs(timeTo, "HH:mm").format("HH:mm"),
    };
  };

  const handleScheduleConfirm = async () => {
    if (!scheduleDate || !scheduleTime) {
      toast.error("Please select both date and time");
      return;
    }

    const scheduleDateTimeISO = dayjs(
      `${scheduleDate.format("YYYY-MM-DD")} ${scheduleTime.format("HH:mm")}`
    ).toISOString();

    try {
      setProcessingModalOpen(true);
      const res = await PropertyApi.updateOnboardingPost(
        {
          schedule_datetime: scheduleDateTimeISO,
          schedule_type: "schedule_datetime",
        },
        onboarding_post_id!
      );

      if (res?.data?.success) {
        setLocalPostStatus("scheduled");
        toast.success("Post scheduled successfully!");
        setShowScheduleForm(false);
      } else {
        toast.error(res?.data?.message || "Failed to update schedule");
      }
    } finally {
      setProcessingModalOpen(false);
    }
  };

  useEffect(() => {
    if (onBoarding?.schedule_datetime) {
      setScheduleDateTime(dayjs(onBoarding.schedule_datetime));
      if (onBoarding?.schedule_type !== "post_now") {
        setShowScheduleForm(true);
      }
    }
  }, [onBoarding]);

  const handleShowScheduleForm = () => {
    setShowScheduleForm(true);

    setTimeout(() => {
      scheduleFormRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const designActivityMap: Record<string, any> = {
    image_post: onBoarding?.image_post_design_activity_ref,
    story_post: onBoarding?.story_post_design_activity_ref,
    video_post: onBoarding?.video_post_design_activity_ref,
    reel_post: onBoarding?.reel_post_design_activity_ref,
  };

  const currentDesignActivity = selectedPostType
    ? designActivityMap[selectedPostType]
    : null;

  const filteredDesignActivities = (() => {
    if (!currentDesignActivity) return [];

    const base = [currentDesignActivity];

    if (currentDesignActivity?.design_task_id?.child_design_tasks?.length) {
      base.push(
        ...currentDesignActivity.design_task_id.child_design_tasks.map(
          (child: any) => ({
            ...currentDesignActivity,
            design_task_id: {
              ...currentDesignActivity.design_task_id,
              output_image_path: child.output_image_path,
              task_status:
                child.task_status ??
                currentDesignActivity.design_task_id.task_status,
            },
          })
        )
      );
    }

    return base;
  })();

  const renderDesignImage = (item: any) => {
    const designActivityRef = item?._id ? item : null;

    const assetUrlRaw = designActivityRef?.design_task_id?.output_image_path;
    const postType =
      designActivityRef?.design_post_type || item?.design_post_type;
    const designTaskStatus = designActivityRef?.design_task_id?.task_status;

    const isLoading = designTaskStatus === CommonEnums.taskStatus.queued;
    const isErrored = designTaskStatus === CommonEnums.taskStatus.errored;

    const assetUrl = assetUrlRaw
      ? CommonHelpers.getImageUrlFromImageTool({ path: assetUrlRaw })
      : null;

    // --- Error State ---
    if (isErrored) {
      return (
        <div className="activity-image-section image-placeholder-container">
          <img
            src="/images/image-video-generation-error-fallback-image-for-card.png"
            alt="Error Preview"
            className="activity-thumbnail placeholder-image"
          />
        </div>
      );
    }

    if (isLoading) {
      const fallback =
        postType === CommonEnums.postType.video_post.key
          ? "/images/square-fallback-image-for-video-preview.png"
          : "/images/square-fallback-image-for-image-preview.png";

      return (
        <div className="activity-image-section image-placeholder-container">
          <img
            src={fallback}
            alt="Loading Preview"
            className="activity-thumbnail placeholder-image"
          />
          <div className="loader-container">
            <CustomPageLoader className="activity-card-loader" />
            <p className="processing-text font-poppins-400">Processing...</p>
          </div>
        </div>
      );
    }

    if (postType === CommonEnums.postType.story_post.key) {
      return (
        <div className="activity-image-section story-post-image-container">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Story Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    if (postType === CommonEnums.postType.video_post.key) {
      return (
        <div className="activity-image-section video-placeholder-collection">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Video Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    if (postType === CommonEnums.postType.reel_post.key) {
      return (
        <div className="activity-image-section reel-placeholder-collection">
          <img
            src={
              assetUrl ||
              "/images/image-video-generation-error-fallback-image-for-card.png"
            }
            alt="Reel Preview"
            className="activity-thumbnail"
            onError={(e: any) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "/images/image-video-generation-error-fallback-image-for-card.png";
            }}
          />
        </div>
      );
    }

    return (
      <div className="activity-image-section">
        <img
          src={
            assetUrl ||
            "/images/image-video-generation-error-fallback-image-for-card.png"
          }
          alt="Image Preview"
          className="activity-thumbnail"
          onError={(e: any) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src =
              "/images/image-video-generation-error-fallback-image-for-card.png";
          }}
        />
      </div>
    );
  };

  function resolveReviewTemplateType(postType?: string, listingType?: string) {
    if (
      postType === CommonEnums.postTypes.image_post &&
      listingType === CommonEnums.listing_Type.rent
    ) {
      return CommonEnums.templateTypes.review_for_rent_image_post.slug;
    }
    if (
      postType === CommonEnums.postTypes.story_post &&
      listingType === CommonEnums.listing_Type.rent
    ) {
      return CommonEnums.templateTypes.review_for_rent_story_post.slug;
    }
    if (
      postType === CommonEnums.postTypes.story_post &&
      listingType === CommonEnums.listing_Type.sale
    ) {
      return CommonEnums.templateTypes.review_for_sale_story_post.slug;
    }
    return CommonEnums.templateTypes.review_for_sale_image_post.slug;
  }

  const designStatuses = [
    onBoarding?.image_post_design_activity_ref?.design_status,
    onBoarding?.story_post_design_activity_ref?.design_status,
    onBoarding?.video_post_design_activity_ref?.design_status,
    onBoarding?.reel_post_design_activity_ref?.design_status,
  ].filter(Boolean);

  const hasPendingForUpload = designStatuses.includes(
    "pending_for_social_media_upload"
  );

  const selectedTemplateId = onBoarding
    ? postType === CommonEnums.postTypes.image_post
      ? onBoarding.image_post_design_activity_ref?.design_template_id?._id ||
        onBoarding.template_id?._id ||
        ""
      : postType === CommonEnums.postTypes.story_post
      ? onBoarding.story_post_design_activity_ref?.design_template_id?._id ||
        onBoarding.template_id?._id ||
        ""
      : postType === CommonEnums.postTypes.video_post
      ? onBoarding.video_post_design_activity_ref?.design_template_id?._id ||
        onBoarding.template_id?._id ||
        ""
      : postType === CommonEnums.postTypes.reel_post
      ? onBoarding.reel_post_design_activity_ref?.design_template_id?._id ||
        onBoarding.template_id?._id ||
        ""
      : onBoarding.template_id?._id || ""
    : "";

  function formatPostStatus(status?: string): string {
    if (!status) return "-";
    return status
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  function getPostStatusDisplay(item: any): string {
    if (!item) return "-";

    if (item.post_status === "cancelled") {
      return "Cancelled";
    }

    const designActivityRef =
      item.image_post_design_activity_ref ||
      item.story_post_design_activity_ref ||
      item.video_post_design_activity_ref ||
      item.reel_post_design_activity_ref;

    const scheduleDatetime = item.schedule_datetime
      ? item.schedule_datetime.$date
        ? new Date(item.schedule_datetime.$date)
        : new Date(item.schedule_datetime)
      : null;

    if (scheduleDatetime) {
      return "Scheduled to Post";
    }

    if (!designActivityRef) {
      return formatPostStatus(item.post_status || "-");
    }

    const designStatus = designActivityRef.design_status;

    if (designStatus === "pending_for_social_media_upload") {
      return "Pending Upload";
    } else if (designStatus === "processing") {
      return "Processing...";
    }

    return formatPostStatus(item.post_status || "-");
  }

  const formattedSchedule = onBoarding?.schedule_datetime
    ? dayjs(onBoarding?.schedule_datetime).format("MMMM DD, YYYY [at] hh:mm A")
    : "-";

  const handlePostNow = async () => {
    if (!onboarding_post_id || updating) return;
    setUpdating(true);
    try {
      const res = await PropertyApi.updateOnboardingPost(
        {
          schedule_type: "post_now",
          schedule_datetime: dayjs().toISOString(),
        },
        onboarding_post_id
      );

      setLocalPostStatus("published");
      setDate(dayjs().format("YYYY-MM-DD"));
      setTimeTo(dayjs().format("HH:mm"));

      if (res?.data?.success) {
        toast.success("Post published successfully!");
        fetchPost();
      } else {
        toast.error(res?.data?.message || "Failed to publish post");
      }
    } catch (error) {
      console.error("Error publishing now:", error);
      toast.error("Something went wrong while publishing");
    } finally {
      setUpdating(false);
    }
  };

  const isPostCompleted =
    localPostStatus === "published" || onBoarding?.schedule_type === "post_now";

  return (
    <div className="review-create-configure-post-container">
      <div className="configure-post">
        <h3 className="section-title">Post Preview</h3>
        <div className="right-actions">
          <button
            className="preview"
            disabled={!hasPendingForUpload}
            onClick={() => setIsPreviewOpen(true)}
          >
            Preview
          </button>
        </div>
      </div>

      <div className={`post-preview-wrapper ${isExpanded ? "expanded" : ""}`}>
        {hasPendingForUpload ? (
          <div className="post-preview-card">
            <div className="post-header">
              <img
                src={
                  getImageUrl(
                    onBoarding?.agent_ref?.profile_image_ref
                      ?.compressed_file_path || ""
                  ) || "/images/profile-placeholder-image.png"
                }
                alt="Agent"
                className="avatar"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = "/images/profile-placeholder-image.png";
                }}
              />
              <div className="user-info">
                <strong className="name">
                  {onBoarding.agent_ref?.principal_agent_first_name}{" "}
                  {onBoarding.agent_ref?.principal_agent_last_name}
                </strong>
                <span className="date">{formattedSchedule}</span>
              </div>
            </div>

            <div className="post-text">
              <span className="post-content">
                {isExpanded ? fullText : shortText}
              </span>
              <span className="see-more" onClick={toggleExpand}>
                {isExpanded ? " See less" : " See more"}
              </span>
            </div>

            <div className="carousel-container">
              {renderDesignImage(
                [
                  onBoarding?.image_post_design_activity_ref,
                  onBoarding?.story_post_design_activity_ref,
                  onBoarding?.video_post_design_activity_ref,
                  onBoarding?.reel_post_design_activity_ref,
                ].filter(Boolean)[postPreviewIndex]
              )}

              {[
                onBoarding?.image_post_design_activity_ref,
                onBoarding?.story_post_design_activity_ref,
                onBoarding?.video_post_design_activity_ref,
                onBoarding?.reel_post_design_activity_ref,
              ].filter(Boolean).length > 1 && (
                <>
                  <button
                    className="carousel-button left"
                    onClick={() =>
                      setPostPreviewIndex((prev) =>
                        prev === 0
                          ? [
                              onBoarding?.image_post_design_activity_ref,
                              onBoarding?.story_post_design_activity_ref,
                              onBoarding?.video_post_design_activity_ref,
                              onBoarding?.reel_post_design_activity_ref,
                            ].filter(Boolean).length - 1
                          : prev - 1
                      )
                    }
                  >
                    <LeftArrowIcon />
                  </button>

                  <button
                    className="carousel-button right"
                    onClick={() =>
                      setPostPreviewIndex((prev) =>
                        prev ===
                        [
                          onBoarding?.image_post_design_activity_ref,
                          onBoarding?.story_post_design_activity_ref,
                          onBoarding?.video_post_design_activity_ref,
                          onBoarding?.reel_post_design_activity_ref,
                        ].filter(Boolean).length -
                          1
                          ? 0
                          : prev + 1
                      )
                    }
                  >
                    <RightArrowIcon />
                  </button>
                </>
              )}
            </div>

            {[
              onBoarding?.image_post_design_activity_ref,
              onBoarding?.story_post_design_activity_ref,
              onBoarding?.video_post_design_activity_ref,
              onBoarding?.reel_post_design_activity_ref,
            ].filter(Boolean).length > 1 && (
              <div className="dots-pagination">
                {[
                  onBoarding?.image_post_design_activity_ref,
                  onBoarding?.story_post_design_activity_ref,
                  onBoarding?.video_post_design_activity_ref,
                  onBoarding?.reel_post_design_activity_ref,
                ]
                  .filter(Boolean)
                  .map((_, i) => (
                    <span
                      key={i}
                      className={`dot ${
                        i === postPreviewIndex ? "active" : ""
                      }`}
                      onClick={() => setPostPreviewIndex(i)}
                    />
                  ))}
              </div>
            )}
          </div>
        ) : (
          <div className="post-preview-loading">
            <div className="spinner" />
            <h4>Your request is being processed.</h4>
            <p>
              We’re working on your request! Creating a high-quality output can
              take a little while. We appreciate your patience.
            </p>
            <p className="message">
              Feel free to wait here, or browse other pages. We’ll send you a
              notification when your request is completed.
            </p>
          </div>
        )}
      </div>

      <div className="text-config">
        <div className="post-text-header">
          <h4>Post Text</h4>
          <div className="toggle-same-text">
            <label className="switch-label">
              Same text for all the platforms
              <input
                type="checkbox"
                checked={sameTextToggle}
                onChange={() => setSameTextToggle(!sameTextToggle)}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>
        <div className="platform-header">
          <div className="platform-tabs">
            {tabs.map((tab) => (
              <div
                key={tab}
                className={`platform-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>
        </div>

        <textarea
          className="post-textarea"
          placeholder="Write your post content here..."
          defaultValue={""}
          onInput={(e: React.FormEvent<HTMLTextAreaElement>) => {
            const target = e.currentTarget;
            target.style.height = "auto";
            target.style.height = `${target.scrollHeight}px`;
          }}
        />
      </div>

      <div className="onboarding-post-form">
        <h3 className="section-title">Schedule Date & Time</h3>
        <p>Select date and time to schedule post</p>

        {isPostCompleted && (
          <div className="status-message published">
            <p className="auto-post">
              Post is Completed and Published on{" "}
              {onBoarding?.schedule_datetime
                ? dayjs(onBoarding.schedule_datetime).format(
                    "hh:mm A, DD-MM-YYYY"
                  )
                : `${dayjs().format("hh:mm A")}, ${dayjs().format(
                    "DD-MM-YYYY"
                  )}`}
              .
            </p>
          </div>
        )}

        {!isPostCompleted && (
          <div className="button-group">
            <button
              className={`post-btn ${
                onBoarding?.schedule_type === "post_now" ? "selected" : ""
              }`}
              onClick={handlePostNow}
              disabled={updating}
            >
              Post Now
            </button>

            <button
              className={`schedule-btn ${
                showScheduleForm || selectedButton === "schedule"
                  ? "active selected"
                  : ""
              }`}
              onClick={() => {
                setShowScheduleForm(!showScheduleForm);
                setSelectedButton("schedule");
              }}
            >
              Schedule Post
            </button>
          </div>
        )}

        {onBoarding?.schedule_type !== "post_now" && (
          <div className="datetime-row">
            <div className="datetime-field">
              <label>Date*</label>
              <div className="input-icon-wrapper">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={scheduleDate}
                    onChange={(newValue) => setScheduleDate(newValue)}
                    format="DD/MM/YYYY"
                    slots={{ textField: TextField }}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        size: "small",
                        InputProps: { className: "input" },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>

            <div className="datetime-field">
              <label>Time*</label>
              <div className="input-icon-wrapper">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={scheduleTime}
                    onChange={(newValue) => setScheduleTime(newValue)}
                    ampm
                    format="hh:mm A"
                    slots={{ textField: TextField }}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        size: "small",
                        InputProps: { className: "input" },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>
        )}

        <div className="form-actions">
          <button
            className="discard-btn"
            onClick={() => {
              setDate("");
              setTimeTo("");
            }}
          >
            Discard Changes
          </button>

          <button className="confirm-btn" onClick={handleScheduleConfirm}>
            Save
          </button>
        </div>
      </div>

      <Modal
        open={processingModalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setProcessingModalOpen(false);
          }
        }}
        aria-labelledby="processing-modal"
        className="add-property-modal styled-modal"
        disableEscapeKeyDown
      >
        <div className="modal-center-wrapper">
          <div className="loading-content-wrapper">
            <div className="loading-container">
              <div className="spinner" />
              <p className="loading-text">
                Processing your request
                <span className="desktop-break">
                  <br />
                </span>
                Please wait...
              </p>
            </div>
          </div>
        </div>
      </Modal>

      {isPreviewOpen && (
        <PreviewModal
          open={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
          images={
            [
              onBoarding?.image_post_design_activity_ref?.design_task_id
                ?.output_image_path
                ? CommonHelpers.getImageUrlFromImageTool({
                    path: onBoarding.image_post_design_activity_ref
                      .design_task_id.output_image_path,
                  })
                : null,
              onBoarding?.story_post_design_activity_ref?.design_task_id
                ?.output_image_path
                ? CommonHelpers.getImageUrlFromImageTool({
                    path: onBoarding.story_post_design_activity_ref
                      .design_task_id.output_image_path,
                  })
                : null,
              onBoarding?.video_post_design_activity_ref?.design_task_id
                ?.output_image_path
                ? CommonHelpers.getImageUrlFromImageTool({
                    path: onBoarding.video_post_design_activity_ref
                      .design_task_id.output_image_path,
                  })
                : null,
              onBoarding?.reel_post_design_activity_ref?.design_task_id
                ?.output_image_path
                ? CommonHelpers.getImageUrlFromImageTool({
                    path: onBoarding.reel_post_design_activity_ref
                      .design_task_id.output_image_path,
                  })
                : null,
            ].filter(Boolean) as string[]
          }
          initialIndex={postPreviewIndex}
        />
      )}
    </div>
  );
};

export default OnBoardingConfigurePost;
